import VueI18n from 'vue-i18n'
import Vue from 'vue'
import locales from "@/locales";

Vue.use(VueI18n)

let locale, fallbackLocale, messages

locale = fallbackLocale = locales[0]
messages = {}

locales.forEach(function (lang) {
  messages[lang] = require(`./locales/${lang}.yml`)
})

export default new VueI18n({
  locale,
  fallbackLocale,
  messages
})
